const $ = require("jquery");
require('./conversions.js');

$.fn.hasAttr = function(name) {
	return this.attr(name) !== undefined;
};

/* GENERAL */
$('[data-tab-selector]').on('click', function(event) {
	var $this = $(this),
	    tab = $this.attr('data-tab-selector'),
	    multiple = $this.hasAttr('data-tab-id') ? $this.attr('data-tab-id') : false,
	    $tab = $('[data-tab="'+tab+'"]'+(multiple?'[data-tab-id="'+multiple+'"]':'')),
	    $others = $('[data-tab]'+(multiple?'[data-tab-id="'+multiple+'"]':'')).not($tab);

	$tab.addClass('show').removeClass('hide');
	$others.addClass('hide').removeClass('show');
});

$('img[alt=""]').each(function(){
	var $img = $(this);
	var filename = $img.attr('src');
	var clean = filename.substring((filename.lastIndexOf('/'))+1, filename.lastIndexOf('.')).replace(/([\-\_\+\.]|(min)$)/g, ' ');
	$img.attr('alt', clean);
});

$('a.scroll').click(function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
		var target = $(this.hash);
		var offset = $(this).hasAttr('data-offset') ? $(this).attr('data-offset') : 0;
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		 if (target.length) {
			$('html,body').animate({
				scrollTop: target.offset().top + parseInt(offset, 10)
			}, 1000);
			return false;
		}
	}
});

$('input[name="form"]').each(function(index, el) {
	$(el).val($(this).closest('section').attr('id'));
});

/* POPUPS */
$('[data-popup-open]').on('click', function(event) {
	event.preventDefault();
	var $this = $(this),
		sectionid = $this.closest('section').attr('id'),
		popupname = $this.attr('data-popup-open'),
		$popup = $('[data-popup="'+popupname+'"]');

	$popup.removeClass('hidden').fadeTo(400, 1);
	$('body').addClass('popup-shown');
});

$('[data-popup-bg], [data-popup-close], [data-popup-close]').on('click', function(event) {
	event.preventDefault();
	$('body').removeClass('popup-shown');
	$(this).closest('[data-popup]').fadeTo(400, 0, function(){
		$(this).addClass('hidden');
	});
	if ($(this).attr('data-popup-close') == 'reset') {
		setTimeout(function() {
			$('[data-popup-content]').show();
			$('[data-popup-success]').hide();
			$('[data-popup-failed]').hide();
		}, 450);
	}
});

if ($('#map').length) {
	$.getScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyDFcDolZi_e6rEfpUP0CdP561XAf3UOIK0', function(data, textStatus) {
		var location = {lat: 56.9517925, lng: 24.1259588};

		var styledMapType = new google.maps.StyledMapType(
			[
			{
				"featureType": "administrative",
				"elementType": "all",
				"stylers": [{
					"saturation": -100
				}]
			},
			{
				"featureType": "administrative.province",
				"elementType": "all",
				"stylers": [{
					"visibility": "off"
				}]
			},
			{
				"featureType": "landscape",
				"elementType": "all",
				"stylers": [{
					"color": "#F7F7F7",
					"visibility": "on"
				}]
			},
			{
				"featureType": "poi",
				"elementType": "all",
				"stylers": [{
					"saturation": -100,
					"lightness": 50,
					"visibility": "simplified"
				}]
			},
			{
				"featureType": "poi.park",
				"elementType": "geometry",
				"stylers": [{
					"color": "#E5E5E5",
					"visibility": "simplified"
				}]
			},
			{
				"featureType": "poi.attraction",
				"elementType": "all",
				"stylers": [{
					"visibility": "off"
				}]
			},
			{
				"featureType": "poi.business",
				"elementType": "all",
				"stylers": [{
					"visibility": "off"
				}]
			},
			{
				"featureType": "road",
				"elementType": "all",
				"stylers": [{
					"saturation": -100,
					"visibility": "simplified",
					"lightness": 0
				}]
			},
			{
				"featureType": "transit",
				"elementType": "all",
				"stylers": [{
					"visibility": "off"
				}]
			},
			{
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [{
					"color": "#EDEDED"
				}]
			},
			{
				"featureType": "water",
				"elementType": "labels",
				"stylers": [{
					"color": "#959595"
				}]
			}
			],
			{ name: 'Styled Map' });

		var map = new google.maps.Map(document.getElementById("map"), {
			center: location,
			zoom: 15,
			mapTypeControlOptions: {
				mapTypeIds: ['roadmap', 'satellite', 'styled_map']
			}
		});

		var marker = new google.maps.Marker({
			position: location,
			map: map,
			icon: "/img/map_location.png"
		});

		map.mapTypes.set('styled_map', styledMapType);
		map.setMapTypeId('styled_map');
	});
}

$('.select-styled').click(function(e) {
	e.stopPropagation();
	if ($(this).hasClass('active'))  {
		$(this).removeClass('active').next('ul.select-options').hide();
	} else {
		$(this).addClass('active').next('ul.select-options').show();
	}
});

$('.select-options li').click(function() {
	let $this = $(this);
	let $field = $this.closest('.field');
	let $input_service = $field.find('[type="hidden"]');
	let $select = $field.find('.select');
	let $selectStyled = $select.find('.select-styled');

	$selectStyled.text($this.data('text')).removeClass('active').addClass('selected');
	$input_service.val($this.attr('rel'));
	$input_service.removeClass('error').addClass('ok');
	$this.parent().addClass('selected');
	$field.removeClass('error').addClass('ok');
	$this.parent().hide();
});
